module.exports = __webpack_public_path__ + "static/img/36-北京理工大学附属中学东校区1.4209340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/36-北京理工大学附属中学东校区1.png
// module id = uI4b
// module chunks = 0